import React, { FC } from 'react';
import { Entry } from 'contentful';
import classNames from 'classnames';

import { TypeProductMerchCardExplorerFields } from '@/core/generated-types';
import { HeaderText, ProductMerchCard } from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';
import { ExtendedProductMerchCardProps } from '@/components/common/ProductMerchCard/ProductMerchCard';
import { BackgroundColorWrapper } from '@/components/common/BackgroundColorWrapper';
export interface TypeProductMerchCardExplorerProps
  extends TypeProductMerchCardExplorerFields {
  products: Entry<ExtendedProductMerchCardProps>[];
}

const MAX_WIDTH_2_ITEM_GRID = 'lg:max-w-[1000px]';
const MAX_WIDTH_3_ITEM_GRID = 'lg:max-w-[1200px]';

const USE_2_ITEM_GRID_CARD_COUNTS = [2, 4];

const ProductMerchCardExplorer: FC<TypeProductMerchCardExplorerProps> = ({
  title,
  titleAsH1,
  contentCentered = true,
  description,
  anchorId,
  products,
  backgroundColor,
}) => {
  const allProductsHidden = products.every(
    (product) => product.fields.isHidden,
  );

  if (allProductsHidden) {
    return null;
  }

  const visibleProductsCount = (products || []).filter(
    (product) => !product.fields.isHidden,
  )?.length;

  const gridStyle = USE_2_ITEM_GRID_CARD_COUNTS.includes(visibleProductsCount)
    ? MAX_WIDTH_2_ITEM_GRID
    : MAX_WIDTH_3_ITEM_GRID;

  return (
    <BackgroundColorWrapper
      color={backgroundColor?.fields.color || 'white'}
      classes="px-6 md:container mx-auto py-8 lg:py-[80px]"
      data-testid="product-merch-card-explorer"
    >
      {anchorId && <div id={anchorId} className="relative -top-[110px]" />}
      <HeaderText
        text={title}
        size={titleAsH1 ? HeaderSize.H1 : HeaderSize.H2}
        align={contentCentered ? 'center' : 'left'}
      />
      {description && (
        <p className="mx-auto max-w-2xl text-center leading-8">{description}</p>
      )}
      <div
        className={classNames(
          'flex flex-wrap gap-6 py-8',
          gridStyle,
          contentCentered && 'place-content-center mx-auto',
        )}
      >
        {products &&
          products.map((product) => (
            <ProductMerchCard {...product.fields} key={product.sys.id} />
          ))}
      </div>
    </BackgroundColorWrapper>
  );
};

export default React.memo(ProductMerchCardExplorer);
